/**
 * Stable browser Demo account + fixture gates.
 *
 * Public Demo sign-in is separate from the owner's private test-data tools.
 * Only the two exact testing emails may see those tools. A company domain,
 * public Demo arrival, or free-mode timer does not enable test data.
 */

export const BROWSER_DEMO_USER_ID = 'browser-demo';
export const BROWSER_DEMO_USERNAME = 'demo';
export const BROWSER_DEMO_FIRST_NAME = 'Demo';
/** Matches the 30-minute free-demo window in App.tsx. */
export const BROWSER_DEMO_SESSION_TTL_MS = 30 * 60 * 1000;

export const DEMO_ARRIVAL_STORAGE_KEY = 'zia_demo_arrival_v1';
export const MSA_TEST_DATA_MODE_KEY = 'zia_msa_test_data_mode_v1';
export const MSA_TEST_DATA_FIXTURE_KEY = 'zia_msa_test_data_fixture_v1';
export const MSA_TEST_DATA_EMAILS: readonly string[] = ['support@ziawellnav.com', 'sales@ziawellnav.com'];

export type MsaTestDataFixture = {
  id: string;
  label: string;
  description: string;
};

/** Isolated coverage scenarios; never provider envelopes or live company records. */
export const MSA_TEST_DATA_FIXTURES: readonly MsaTestDataFixture[] = [
  { id: 'coverage-incomplete', label: 'Incomplete work details', description: 'Continue focuses the missing company, facility, dates, or scope.' },
  { id: 'coverage-missing', label: 'Missing agreement coverage', description: 'Add coverage from a sample shared agreement, then reassess.' },
  { id: 'coverage-expired', label: 'Expired agreement term', description: 'Review why a recorded agreement no longer covers the scheduled work.' },
  { id: 'coverage-review', label: 'Evidence awaiting review', description: 'Review sample evidence, record a decision, and inspect its history.' },
  { id: 'coverage-reviewed', label: 'Reviewed requirements', description: 'See accepted sample evidence while work authorization remains separate.' },
] as const;

export function isBrowserDemoUserId(id: string | null | undefined): boolean {
  return String(id || '').trim() === BROWSER_DEMO_USER_ID;
}
